// extracted by mini-css-extract-plugin
export default {"CateringCta":"ebisIjcoq7y0zHYfb66m","CateringCta_content":"_GYfkisQeet9VEFgIz7k","CateringCta_img":"SY_UBksIEy829wA5m_vB","CateringCta_logo":"tAQrZB3v0oMRBX5VqL2R"};